<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e1847">TABLE OF CONTENTS</p>
<p class="cct" id="d7e1897"><a href="#/Crut_9781418557348_epub_c12_r1#Anch0007" id="Anch00110">GEOGRAPHY</a></p>
<p class="cct" id="d7e2037"><span href="#/Crut_9781418557348_epub_c13_r1#Anch0027" id="Anch00342" title="Link target outside of Sample">ENTERTAINMENT</span></p>
<p class="cct" id="d7e2177"><span href="#/Crut_9781418557348_epub_c14_r1#Anch0047" id="Anch00570" title="Link target outside of Sample">HISTORY</span></p>
<p class="cct" id="d7e2277"><span href="#/Crut_9781418557348_epub_c15_r1#Anch0067" id="Anch007102" title="Link target outside of Sample">ARTS &amp; LITERATURE</span></p>
<p class="cct" id="d7e2497"><span href="#/Crut_9781418557348_epub_c16_r1#Anch0087" id="Anch009134" title="Link target outside of Sample">SPORTS &amp; LEISURE</span></p>
<p class="cct" id="d7e2697"><span href="#/Crut_9781418557348_epub_c17_r1#Anch0107" id="Anch011162" title="Link target outside of Sample">SCIENCE &amp; NATURE</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Crut_9781418557348_epub_c10_r1.vue?095420c2